import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import DialogForm from '../Global/Modals/DialogForm';
import { withNamespaces } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import { Formik, Field } from 'formik';
import ProgressButton from '../Global/Buttons/Progress';
import classnames from 'classnames';
import ButtonStyles from '../../styles/button';
import SpacingStyles from '../../styles/helpers/spacing';
import TypographyStyles from '../../styles/typography';

import combineStyles from '../../utils/combineStyles';
//import validationSchema from './ExceptionModal.schema';
import ChippedAutocomplete from '../Global/Inputs/ChippedAutocomplete';
import { buildAvailableContactList } from './helpers';
import { getContactSuggestions } from '../shipment/form/helpers';

export class AssignContactsModal extends PureComponent {
  static propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    allContacts: PropTypes.array.isRequired,
    assignedContacts: PropTypes.array.isRequired
  };
  state = {
    isSubmitting: false,
    contactTyped: '',
    contactsSelected: [],
    availableContacts: buildAvailableContactList(
      this.props.allContacts,
      this.props.assignedContacts
    )
  };
  _handleCancel = resetForm => {
    const { onClose } = this.props;
    resetForm();
    onClose();
  };
  _getSuggestions = async searchTerm => {
    const { availableContacts } = this.state;

    return await getContactSuggestions(availableContacts, searchTerm);
  };

  componentDidUpdate(prevProps) {
    if (
      prevProps.assignedContacts !== this.props.assignedContacts ||
      prevProps.allContacts !== this.props.allContacts
    ) {
      const availableContacts = buildAvailableContactList(
        this.props.allContacts,
        this.props.assignedContacts
      );
      this.setState({ availableContacts });
    }
  }
  refreshAvailableContactsList = selectedContacts => {
    const availableContacts = buildAvailableContactList(
      this.props.allContacts,
      this.props.assignedContacts,
      selectedContacts
    );
    this.setState({ availableContacts });
  };
  render() {
    const { open, onClose, t, classes, onSave } = this.props;
    const { isSubmitting } = this.state;

    return (
      <Formik
        handleSubmit={this._handleOnSave}
        enableReinitialize={true}
        //    validationSchema={validationSchema({ t })}
        initialValues={{
          contacts: []
        }}
        onSubmit={async (values, actions) => {
          this.setState({ isSubmitting: true });
          const contacts = values.contacts.map(contact => {
            return contact.value;
          });
          const savedSuccessfully = await onSave(contacts);
          if (savedSuccessfully) {
            actions.resetForm();
            this.setState({ isSubmitting: false });
            onClose();
          }
        }}
        render={({ values, handleChange, handleSubmit, handleReset }) => (
          <DialogForm
            open={open}
            title={t('Assign Contact(s)')}
            onClose={onClose}
            footer={
              <Fragment>
                <div className={classes.spacer} />
                <Button
                  className={classes.button}
                  onClick={() => {
                    this._handleCancel(handleReset);
                  }}
                  color={'primary'}
                  classes={{ label: classes.buttonLabel }}
                >
                  {t('Cancel')}
                </Button>
                <ProgressButton
                  color="primary"
                  className={classnames(classes.button)}
                  classes={{
                    label: classnames(classes.buttonLabel)
                  }}
                  disabled={values.contacts.length === 0}
                  onClick={handleSubmit}
                  isSubmitting={isSubmitting}
                >
                  {t('Assign')}
                </ProgressButton>
              </Fragment>
            }
          >
            <Grid container spacing={16}>
              <Grid item lg={12}>
                <p
                  className={classnames(
                    classes.headline7,
                    classes.normalWeight
                  )}
                >
                  {t(
                    'Note: A single contact can be assigned to many locations'
                  )}
                  .
                </p>
              </Grid>
              <Grid item lg={12}>
                <Field
                  name="contacts"
                  render={({ field, form }) => (
                    <ChippedAutocomplete
                      getSuggestions={this._getSuggestions}
                      values={values.contacts} //chipped list
                      onChange={evt => {
                        this.refreshAvailableContactsList(evt.target.value);
                        handleChange(evt);
                      }}
                      field={field}
                      form={form}
                      label={t('Contact Names')}
                    />
                  )}
                />
              </Grid>
            </Grid>
          </DialogForm>
        )}
      />
    );
  }
}
const translatedAssignContactsModal = withNamespaces()(AssignContactsModal);
export default withStyles(
  combineStyles(SpacingStyles, TypographyStyles, ButtonStyles)
)(translatedAssignContactsModal);
